module.exports = __webpack_public_path__ + "static/media/SDG3.ceb893e2.mp4";